import React, { Component } from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';
import ModalLogIntentos from '../components/ModalLogIntentos';


class HistorialModificaciones extends Component {
    constructor(props) {
        super(props);
        this.openLogModal = this.openLogModal.bind(this);
    }

    openLogModal(elemento) {
        //Solo si es estado ENVIADO se llama a la función de mostrar el modal
       // if (elemento.target.className == "log-dot-review") {
            //Id de novedad, el mismo servira para hacer la consulta y 
            //obtener los datos que se mostrarán en el modal de log
            let novedadId = elemento.target.id;
            if(novedadId != ""){
                this.props.obtenerDatosLogIntentos(novedadId);
                //OpenModal(ID de modal a mostrar, null, El ID de la novedad para mostrar el log, bool para abrir o cerrar el modal)
                this.props.openModalLogIntentos(3, null, novedadId, true);
            }
       // }
    }

    render() {

        const rowsModificaciones = this.props.listaModificaciones == undefined ? [] : this.props.listaModificaciones.map(modif => {
            let estadoAMostrar = "";
            let claseEstado = "", claseDot = "";
            let motivoDescripcion = "";

            let fechaModif = modif.FechaHoraModificacion ? GlobalHelper.ConvertirFechaDB(modif.FechaHoraModificacion) : "";
            let fechaConf = modif.FechaHoraConfirmacion ? GlobalHelper.ConvertirFechaDB(modif.FechaHoraConfirmacion) : "";

            let fechaIntAdm = modif.FechaInterfazAdministradora ? GlobalHelper.ConvertirFechaDB(modif.FechaInterfazAdministradora) : "";
            let fechaResAdm = modif.FechaRespuestaAdministradora ? GlobalHelper.ConvertirFechaDB(modif.FechaRespuestaAdministradora) : "";



            switch (modif.NovedadEstadoId) {
                case 1:
                    estadoAMostrar = "COMPLETADA"
                    claseEstado = "modal-news-modifications-button-lightblue-central-rectangle"
                    break;

                case 2:
                    estadoAMostrar = "CONFIRMADO"
                    claseEstado = "modal-news-modifications-button-lightgreen-central-rectangle"
                    break;

                case 3:
                    estadoAMostrar = "DENEGADO"
                    claseEstado = "modal-news-modifications-button-lightred-central-rectangle"
                    claseDot = "dot"
                    motivoDescripcion = modif.MotivoDenegacion
                    break;

                case 4:
                    estadoAMostrar = "ENVIADA"
                    claseEstado = "modal-news-modifications-button-green-enviada-rectangle"
                    claseDot = "log-dot-review"
                    break;

                case 5:
                    estadoAMostrar = "ACEP. ADM."
                    claseEstado = "modal-news-modifications-button-green-aceptada-rectangle"
                    break;

                case 6:
                    estadoAMostrar = "RECH. ADM."
                    claseEstado = "modal-news-modifications-button-red-rechazada-rectangle"
                    motivoDescripcion = modif.MotivoRechazo
                    claseDot = "dot"
                    break;

                case 7:
                    estadoAMostrar = "CANCELADA"
                    claseEstado = "modal-news-modifications-button-red-central-rectangle"
                    break;

            }
            return (
                <tr>
                    <td onClick={claseDot == "log-dot-review" ? this.openLogModal : null} id={modif.Id}> 
                        <div data-toggle="tooltip" data-title={motivoDescripcion}>
                            <label className={claseEstado}>{estadoAMostrar}</label>
                            <span className={claseDot} onClick={claseDot == "log-dot-review" ? this.openLogModal : null} id={modif.Id}></span>
                            <span>
                                {this.props.modalLogIntentos && this.props.IdmodalLogIntentos == modif.Id ?                                
                                    <ModalLogIntentos datosLogIntentos={this.props.datosLogIntentos} openModal={this.props.openModalLogIntentos}></ModalLogIntentos> :
                                    null}
                            </span>
                        </div>
                    </td>
                    <td>
                        {modif.DescripcionAnterior ? modif.DescripcionAnterior : modif.ValorAnterior}
                    </td>
                    <td>
                        {modif.DescripcionNovedad ? modif.DescripcionNovedad : modif.ValorNovedad}
                    </td>
                    <td>
                        {modif.UsuarioLoginModificacion}
                    </td>
                    <td>
                        {fechaModif}
                    </td>
                    <td>
                        {modif.UsuarioLoginConfirmacion}
                    </td>
                    <td>
                        {fechaConf}
                    </td>
                    <td>
                        {fechaIntAdm}
                    </td>
                    <td>
                        {fechaResAdm}
                    </td>
                </tr>)
        })

        return (
            <div>
                <div className='modalDemandaHeader bottom-separator-HistorialModificacion'>
                    <div className='modalProcesosDocumentadosHeaderText'>
                        Historial de Modificaciones
                </div>
                    <label onClick={() => this.props.openModal(false, null, this.props.seccion)} className='ti-close clickable modalProcesosClose closeProcesosDemanda'></label>
                </div>
                <div className='modalHistorialContenedorTabla'>
                    <table className="HistorialModificacionesTabla" id="HistorialModificacionesTable" rowclick={this.openLogModal} >
                        <thead>
                            <tr>
                                <th width="110px" className="HistorialModificacionesEstado" rowSpan="2">Estado</th>
                                <th width="110px" rowSpan="2">Valor Original</th>
                                <th width="110px" rowSpan="2">Nuevo Valor </th>
                                <th colSpan="2">Editado</th>
                                <th colSpan="2">Confirmado</th>
                                <th colSpan="2">Procesadora</th>
                            </tr>
                            <tr>
                                <th width="100px">Usuario</th>
                                <th width="100px">Fecha</th>
                                <th width="100px">Usuario</th>
                                <th width="100px">Fecha</th>
                                <th width="100px">F. Envío</th>
                                <th width="100px">F. Recepción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rowsModificaciones}
                        </tbody>
                    </table>
                </div>
                {/* <div>
                {this.props.modalState &&
                    <ModalHistorialModificaciones
                        data={this.props.dataLogNovedadSaga}
                    />
                }
            </div> */}
            </div>
        );
    }
}
export default HistorialModificaciones;